export const APP = 'app';
export const TOPIC_TREE = 'topicTreeV2';
export const PERSONALIZED_FEED = 'personalizedFeedV2';
export const RECOMMENDED_SOLUTIONS = 'recommendedSolutionsV2';
export const NNA = 'nnaV2';
export const TRACKERS = 'trackersV2';
export const SEARCH = 'searchV2';
export const SEARCH_TOP_CONTACT_REASONS = 'searchTopContactReasonsV2';
export const AUTH_CONFIRMATION_PROMPT = 'authConfirmationPromtV2';
export const CONTACT_TOPIC_TREE_INTENTS = 'contactTopicTreeIntentsV2';
export const CONTACT_CHANNEL_OPTIONS = 'contactChannelOptionsV2';
export const CONTACT_CALL_US = 'callUsInfoV2';
export const CHAT_BOT = 'chatBotV2';
export const CONTACT_ARTICLE = 'contactArticleV2';
export const LOCATION = 'location';
export const OCP_CONTEXT_RESPONSE = 'ocpContextResponse';
export const POST_CHAT_BOT_ELIGIBILITY = 'postChatBotEligibility';
export const MODAL = 'modal';
export const PERSISTENT_EMAIL_FORM = 'persistEmailForm';
